import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { UserMFASettingModel } from 'app/models/login.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { SecurityService } from 'app/services/security.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends NexusComponent {
  public user_mfa_setting_model: UserMFASettingModel = new UserMFASettingModel();
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public form = new UntypedFormGroup({
    mfa_enabled: this.CreateFormControl(false),
    application_id: this.CreateFormControl(environment.client_id),
    mfa_method:this.CreateFormControl('EMAIL')
  });

  constructor(private security_service: SecurityService) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.load_settings();
    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.user_mfa_setting_model);
    });

  }
  load_settings() {
    this.StartSpinner();
    this.security_service.GetSecuritySettings().subscribe({
      next:(data)=>{
        this.user_mfa_setting_model= data;
        if (this.user_mfa_setting_model) {
          this.form.patchValue(this.user_mfa_setting_model);
        }
        this.StopSpinner();
      },
      error:(err)=>{   this.StopSpinner();}
    })
  }
  submit() {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.security_service.SaveSecuritySettings(this.user_mfa_setting_model).subscribe(
      data => {
            this.StopSpinner();
            this.form_result.Success("Saved Successfully");

      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });
  }
}
